import type { ThirdPartyFeedbackProvider } from 'api/integrationsConfig'
import { integrationsList } from 'utilities/integrations'

// "Thanx collection wins the overlap": a connected partner tool owns the
// merchant's feedback only while Thanx itself is not collecting. The Overview
// and the Settings panes both draw the line here, so they cannot disagree about
// who owns feedback. Still an unconfirmed default for the overlap rows (see
// resolveOverviewState's isUnconfirmedDefault).
export const owningThirdPartyProvider = (
  isCollecting: boolean,
  thirdPartyProvider: ThirdPartyFeedbackProvider | null | undefined
): ThirdPartyFeedbackProvider | null =>
  isCollecting ? null : thirdPartyProvider ?? null

const FEEDBACK_INTEGRATIONS =
  integrationsList.find(category => category.key === 'feedback')
    ?.integrations ?? []

// The Integration Center's own title for the tool, so a merchant sees the name
// they already know it by, and the Overview and Settings never name it
// differently.
export const feedbackProviderName = (
  provider: ThirdPartyFeedbackProvider | null | undefined
): string | undefined => {
  if (!provider) return undefined

  return (
    FEEDBACK_INTEGRATIONS.find(integration => integration.key === provider)
      ?.title ?? provider
  )
}
